import one from "../../../assets/avatars/1.svg";
import two from "../../../assets/avatars/2.svg";
import three from "../../../assets/avatars/3.svg";
import four from "../../../assets/avatars/4.svg";
import five from "../../../assets/avatars/5.svg";
import six from "../../../assets/avatars/6.svg";
import seven from "../../../assets/avatars/7.svg";
import eight from "../../../assets/avatars/8.svg";
import twitter from "../../../assets/twitter.svg";

export const testimonialsList = [
  {
    avatar: one,
    clientName: "Darrell Steward",
    company: twitter,
    socialMediaLink: "@darrels",
    testimonial:
      "You made it so simple. My new site is so much faster and easier to work with than my old site. I just choose the page, make the change and click save.",
    hashtag: "#another",
  },
  {
    avatar: two,
    clientName: "Leslie Alexander",
    company: twitter,
    socialMediaLink: "@lesslie",
    testimonial:
      "Simply the best. Better than all the rest. I’d recommend this product to beginners and advanced users.",
    hashtag: "#postcrafts",
  },
  {
    avatar: three,
    clientName: "Jenny Wilson",
    company: twitter,
    socialMediaLink: "@jennywilson",
    testimonial:
      "This is a top quality product. No need to think twice before making it live on web.",
    hashtag: "#make_it_fast",
  },
  {
    avatar: four,
    clientName: "Kristin Watson",
    company: twitter,
    socialMediaLink: "@kristinwatson2",
    testimonial:
      "Finally, I’ve found a template that covers all bases for a bootstrapped startup. We were able to launch in days, not months.",
    hashtag: "#postcrafts",
  },
  {
    avatar: five,
    clientName: "Guy Hawkins",
    company: twitter,
    socialMediaLink: "@jennywilson",
    testimonial:
      "This is a top quality product. No need to think twice before making it live on web.",
    hashtag: "#make_it_fast",
  },
  {
    avatar: six,
    clientName: "Marvin McKinney",
    company: twitter,
    socialMediaLink: "@jennywilson",
    testimonial:
      "With Postcrafts, it’s quicker with the customer, the customer is more ensured of getting exactly what they ordered, and I’m all for the efficiency.",
    hashtag: "#dev #tools",
  },
  {
    avatar: seven,
    clientName: "Annette Black",
    company: twitter,
    socialMediaLink: "@jennywilson",
    testimonial:
      "You made it so simple. My new site is so much faster and easier to work with than my old site. I just choose the page, make the change and click save.",
    hashtag: "#another",
  },
  {
    avatar: eight,
    clientName: "Floyd Miles",
    company: twitter,
    socialMediaLink: "@jennywilson",
    testimonial:
      "My new site is so much faster and easier to work with than my old site. I just choose the page, make the change and click save.",
    hashtag: "#postcrafts",
  },
];
